import { folderIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Folder = createIcon({
  displayName: 'Folder',
  paths: [
    'M459.273 85.333h-288.597c-47.147 0-85.333 38.229-85.333 85.333v640c0 47.104 38.187 85.333 85.333 85.333h682.667c47.104 0 85.333-38.229 85.333-85.333v-512c0-47.104-38.229-85.333-85.333-85.333h-256l-61.739-80.853c-14.464-28.885-44.032-47.147-76.331-47.147zM459.273 170.667l85.333 128h308.736v512h-682.667v-640h288.597zM298.667 682.667h256c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM298.667 512c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h426.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-426.667z'
  ],
  canvasPaths: canvasIconPaths(folderIcon)
})
